import global from './global'

let mixins = {
  global
};

export default mixins;



// WEBPACK FOOTER //
// ./src/mixin/index.js